module.exports = __webpack_public_path__ + "img/waiting-approval-user.e1ed72b0.svg";